module.exports = __webpack_public_path__ + "static/media/screen1.224fdd2f.png";